document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-nyumi-moods]').forEach((section) => {
    const buttons = section.querySelectorAll('[data-mood-target]');
    const messages = section.querySelectorAll('[data-mood-message]');
    buttons.forEach((button) => {
      button.addEventListener('click', () => {
        buttons.forEach((item) => item.classList.remove('is-active'));
        buttons.forEach((item) => item.setAttribute('aria-pressed', 'false'));
        messages.forEach((item) => item.classList.remove('is-active'));
        button.classList.add('is-active');
        button.setAttribute('aria-pressed', 'true');
        const message = section.querySelector(`#${CSS.escape(button.dataset.moodTarget)}`);
        if (message) message.classList.add('is-active');
        const mimi = section.querySelector('.ny-moods__mimi');
        if (mimi && button.dataset.moodImage) {
          mimi.classList.remove('ny-pop');
          mimi.src = button.dataset.moodImage;
          mimi.alt = button.dataset.moodAlt || 'Mimi matching the selected mood';
          requestAnimationFrame(() => mimi.classList.add('ny-pop'));
        }
      });
    });
  });
});
